import { Switch, Typography } from "antd";

const { Text } = Typography;

export interface ToggleOptionProps {
  label: string;
  description: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * A single option rendered as a bordered card: bold label + description + Switch.
 * Shared across the widget configurators (radar, table_2d, player card, stat, player
 * notes) which previously each re-declared or inlined an identical version.
 */
export function ToggleOption({ label, description, checked, onChange }: ToggleOptionProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "8px 10px",
        border: "1px solid #e0e5eb",
        borderRadius: 8,
        background: "#fafbfc",
      }}
    >
      <div>
        <Text strong style={{ fontSize: 12 }}>{label}</Text>
        <br />
        <Text type="secondary" style={{ fontSize: 11 }}>{description}</Text>
      </div>
      <Switch size="small" checked={checked} onChange={onChange} />
    </div>
  );
}
